import api from '../utils/api';

export const testMasterService = {
  getTestMasters: (filters = {}) => {
    let params = {};
    
    if (filters.search) {
      params.search = filters.search;
    }
    
    if (filters.category && filters.category !== '') {
      params.category = filters.category;
    }
    
    if (filters.gender && filters.gender !== '') {
      params.gender = filters.gender;
    }

    return api.get('/admin/testMasters', { params });
  },

  getTestMasterById: (testId) => {
    return api.get(`/admin/testMasters/${testId}`);
  },

  createTestMaster: (testMasterData) => {
    return api.post('/admin/testMasters', { data: testMasterData });
  },

  updateTestMaster: (testId, testMasterData) => {
    return api.put(`/admin/testMasters/${testId}`, { data: testMasterData });
  },

  deleteTestMaster: (testId) => {
    return api.delete(`/admin/testMasters/${testId}`);
  }
};
